import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyAutomationExecutionLimit: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AutomationExecutionLimitMessage" */ '../src/AutomationExecutionLimitMessage.tsx'
			)
		).AutomationExecutionLimitMessageComponent,
});
